/**
 * Accordéons : racine [data-accordion] (ul.accordion.accordion-standard) contenant des
 * .accordion-item avec un .accordion-toggler suivi d'un .accordion-content.
 *   data-toggle-first="false"  ne pas ouvrir le premier élément au chargement
 *   data-name="slug"           nom utilisé par la FAQ pour ouvrir une question à distance
 * Un seul élément ouvert à la fois, animation par max-height (accordion/_content.scss).
 * Gère aussi le bloc accordion_image_v2 : la figure affichée suit l'élément ouvert.
 * Remplace le composant Vue AccordionStandard (mixin AccordionComponent).
 *
 * API : UNYC.accordion.toggleItem('#faq-12', 'slug') — utilisée par 41-faq.js, qui s'exécute
 * après ce module (ordre alphabétique des fichiers).
 */
(function () {
    'use strict';

    const TOGGLER = 'accordion-toggler';
    const CONTENT = 'accordion-content';

    let counter = 0;

    const syncExpanded = (toggler) => {
        toggler.setAttribute('aria-expanded', toggler.classList.contains('active') ? 'true' : 'false');
    };

    const toggle = (toggler, content) => {
        toggler.classList.toggle('active');
        content.style.maxHeight = content.style.maxHeight !== '0px' ? '0' : `${content.scrollHeight}px`;
        syncExpanded(toggler);
    };

    /**
     * Bloc accordion_image_v2 : masque toutes les figures (et retire les vidéos lancées),
     * puis affiche celle de l'élément cliqué (data-numaccord ↔ data-accordeon-num).
     */
    const switchImage = (toggler) => {
        const block = toggler.closest('.accordion-image-v2');
        if (!block) return;

        const resetVideo = (container) => {
            const iframe = container.querySelector('iframe');
            if (iframe) iframe.remove();

            const video = container.querySelector('.showvideo');
            if (video) video.removeAttribute('style');
        };

        block.querySelectorAll('.image_container figure').forEach((figure) => {
            figure.classList.add('hidden');
            resetVideo(figure);
        });

        block.querySelectorAll('.image_container_mobile').forEach(resetVideo);

        const item = toggler.closest('.accordion-item');
        const index = item ? item.getAttribute('data-numaccord') : null;
        const figure = index !== null ? block.querySelector(`figure[data-accordeon-num="${index}"]`) : null;

        if (figure) figure.classList.remove('hidden');
    };

    const create = (root) => {
        const togglers = UNYC.qsa(`.${TOGGLER}`, root);
        const contents = UNYC.qsa(`.${CONTENT}`, root);
        const openFirst = root.dataset.toggleFirst !== 'false';
        const state = { active: null };

        if (!root.id) root.id = `accordion-${++counter}`;

        togglers.forEach((toggler, index) => {
            // Les déclencheurs sont des <p> / <h3> : on les rend opérables au clavier.
            const content = toggler.nextElementSibling;

            toggler.setAttribute('tabindex', '0');
            toggler.setAttribute('role', 'button');
            syncExpanded(toggler);

            if (content && content.classList.contains(CONTENT)) {
                if (!content.id) content.id = `${root.id}-panel-${index + 1}`;
                toggler.setAttribute('aria-controls', content.id);
            }

            toggler.addEventListener('keydown', (event) => {
                if (event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault();
                    toggler.click();
                }
            });

            toggler.addEventListener('click', (event) => {
                event.preventDefault();

                switchImage(toggler);

                const current = toggler.nextElementSibling;
                const previous = state.active ? state.active.nextElementSibling : null;

                if (state.active && toggler !== state.active && previous && previous.classList.contains(CONTENT)) {
                    state.active.classList.remove('active');
                    previous.style.maxHeight = '0';
                    syncExpanded(state.active);
                }

                if (current && current.classList.contains(CONTENT)) {
                    toggle(toggler, current);
                    state.active = toggler;
                }
            });
        });

        contents.forEach((content, index) => {
            if (openFirst && index === 0) {
                content.style.maxHeight = 'initial';
                state.active = togglers[0] || null;
                if (state.active) {
                    state.active.classList.toggle('active');
                    syncExpanded(state.active);
                }

                window.setTimeout(() => {
                    content.style.maxHeight = `${content.scrollHeight}px`;
                }, 500);
            } else {
                content.style.maxHeight = '0';
            }
        });
    };

    UNYC.accordion = {
        /**
         * Bascule l'élément `selector` (ex. "#faq-12") des accordéons dont data-name vaut `name`.
         * @returns {boolean} vrai si un élément a été trouvé.
         */
        toggleItem(selector, name) {
            let found = false;

            UNYC.qsa('[data-accordion]').forEach((root) => {
                if (root.dataset.name !== name) return;

                const item = root.querySelector(selector);
                const toggler = item ? item.querySelector(`.${TOGGLER}`) : null;
                const content = item ? item.querySelector(`.${CONTENT}`) : null;

                if (toggler && content) {
                    toggle(toggler, content);
                    found = true;
                }
            });

            return found;
        },
    };

    UNYC.register('accordion', () => {
        UNYC.init('[data-accordion]', 'accordion', create);
    });
})();
